import { styled } from '@mui/material/styles';

export const ViewToggle = styled('div')({
    display: 'flex',
    width: 'fit-content',
    borderRadius: 8,
    overflow: 'hidden',
    border: '1px solid rgba(0, 0, 0, 0.12)',
});

const StyledViewToggleButton = styled('button', {
    shouldForwardProp: prop => prop !== 'active',
})(({ active }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    padding: '4px 8px',
    border: 'none',
    cursor: 'pointer',
    fontFamily: 'Rubik, sans-serif',
    fontSize: '0.75rem',
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '0.1px',
    backgroundColor: active ? 'rgba(0, 0, 0, 0.08)' : 'transparent',
    color: active ? 'var(--text-primary)' : 'rgba(0, 0, 0, 0.3)',
    transition: 'background-color 0.2s, color 0.2s',
    '&:hover': {
        backgroundColor: active ? 'rgba(0, 0, 0, 0.08)' : 'var(--action-hover)',
    },
}));

export const ViewToggleButton = ({ type = 'button', ...props }) => <StyledViewToggleButton type={type} {...props} />;
